/**
 * P1 — catálogo canônico (AN-PP1 §1.3 e §2.2; DEV-PP1-F1): constantes e mensagens dos erros
 * novos da API de produtos. As chamadas ficam na seção "P1" de `services/produtoService`.
 */

/** Palavra que o ADMIN digita para confirmar a retirada (AN-PP1 §2.2). */
export const CONFIRMACAO_RETIRADA = 'RETIRAR'

/** Códigos de erro do catálogo canônico em texto legível. */
export const MENSAGENS_ERRO_PRODUTO_P1: Record<string, string> = {
  CODIGO_OBRIGATORIO: 'Informe o código do produto.',
  CODIGO_INVALIDO:
    'Código inválido: use letras maiúsculas, números e "_", começando por letra (3 a 64 caracteres). Códigos "X_…" são reservados à migração.',
  CODIGO_JA_EXISTE: 'Já existe um produto com este código.',
  CODIGO_CATEGORIA_INCOMPATIVEL: 'Este código canônico pertence a outra categoria.',
  CODIGO_IMUTAVEL: 'O código do produto não pode ser alterado.',
  STATUS_INVALIDO: 'Status inválido para um produto novo.',
  MOTIVO_OBRIGATORIO: 'Informe o motivo da alteração.',
  CONFIRMACAO_OBRIGATORIA: `Para retirar o produto, digite ${CONFIRMACAO_RETIRADA} na confirmação.`,
  PRODUTO_RETIRADO: 'Produto retirado: o status é terminal e não pode mais ser alterado.',
  STATUS_FIXO_DO_PRODUTO: 'O status de "Outra necessidade" é fixo.',
  PRODUTO_CANONICO_NAO_EXCLUIVEL: 'Produto do catálogo canônico não pode ser excluído — use a retirada.',
  PRODUTO_NAO_ENCONTRADO: 'Este produto não existe mais. Volte à lista de produtos.',
  ACCESS_DENIED: 'Só o administrador altera o catálogo de produtos.',
}

/** Mensagem legível de um erro da API de produtos (código conhecido → texto; 403 → sem permissão). */
export const mensagemErroProdutoP1 = (e: unknown, padrao: string): string => {
  const codigo = (e as { data?: { errorCode?: unknown } } | null)?.data?.errorCode
  if (typeof codigo === 'string' && MENSAGENS_ERRO_PRODUTO_P1[codigo]) return MENSAGENS_ERRO_PRODUTO_P1[codigo]
  if ((e as { status?: number } | null)?.status === 403) return MENSAGENS_ERRO_PRODUTO_P1.ACCESS_DENIED
  const m = (e as { message?: unknown } | null)?.message
  return typeof m === 'string' && m.trim() ? m : padrao
}
